import { createContext, useContext } from "react";
import type { AuthUser } from "../../api/common";
import type { CompanyContextValue } from "./CompanyContext.types";
import { useCompanyContextViewModel } from "./CompanyContext.vm";

const CompanyContext = createContext<CompanyContextValue>({
	companies: [],
	selectedCompany: null,
	setSelectedCompany: () => {},
	contact: null,
	isLoading: false,
	isInitialized: false,
});

interface CompanyContextProviderProps {
	user: AuthUser | undefined;
	children: React.ReactNode;
}

export function CompanyContextProvider({ user, children }: CompanyContextProviderProps) {
	const value = useCompanyContextViewModel(user);
	return <CompanyContext.Provider value={value}>{children}</CompanyContext.Provider>;
}

export function useCompanyContext(): CompanyContextValue {
	return useContext(CompanyContext);
}

export { CompanyContext };
